import type { IMarkTheme } from '../../types';

export const defaultMarkTheme: IMarkTheme = {
  symbol: {
    shape: 'circle',
    size: 8
  },
  text: {
    fontSize: 14,
    fill: '#000000'
  }
};
